// MoebelSymbol - dezente Symbole für Raum-Orientierung
// Reine SVG-Icons (von oben gesehen, einfach gehalten)
import React from 'react';

const STYLES = {
  fill: '#f8fafc',
  stroke: '#475569',
  strokeOpacity: 0.6,
  fillOpacity: 0.7,
};

function Bett({ x, y, w, h }) {
  // Bett: Rechteck mit Kissen-Andeutung oben
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={3}
            fill="#fef3c7" stroke="#a8a29e" strokeWidth={0.8} fillOpacity={0.8} />
      {/* Kissen */}
      <rect x={x + w * 0.05} y={y + h * 0.05} width={w * 0.4} height={h * 0.18}
            rx={2} fill="#fff" stroke="#d6d3d1" strokeWidth={0.5} />
      <rect x={x + w * 0.55} y={y + h * 0.05} width={w * 0.4} height={h * 0.18}
            rx={2} fill="#fff" stroke="#d6d3d1" strokeWidth={0.5} />
      {/* Decke-Linie */}
      <line x1={x} y1={y + h * 0.30} x2={x + w} y2={y + h * 0.30}
            stroke="#a8a29e" strokeWidth={0.6} />
    </g>
  );
}
function Tisch({ x, y, w, h }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={2}
            fill="#e7d4b5" stroke="#92400e" strokeWidth={0.8} fillOpacity={0.85} />
      {/* Maserung */}
      <line x1={x + w * 0.3} y1={y + 2} x2={x + w * 0.3} y2={y + h - 2}
            stroke="#92400e" strokeOpacity={0.3} strokeWidth={0.3} />
      <line x1={x + w * 0.6} y1={y + 2} x2={x + w * 0.6} y2={y + h - 2}
            stroke="#92400e" strokeOpacity={0.3} strokeWidth={0.3} />
    </g>
  );
}
function Stuhl({ x, y, w, h }) {
  return (
    <g>
      <rect x={x + w * 0.1} y={y + h * 0.1} width={w * 0.8} height={h * 0.8} rx={2}
            fill="#cbd5e1" stroke="#475569" strokeWidth={0.8} fillOpacity={0.75} />
      {/* Lehne */}
      <rect x={x + w * 0.1} y={y} width={w * 0.8} height={h * 0.15}
            fill="#94a3b8" stroke="#475569" strokeWidth={0.5} />
    </g>
  );
}
function Sofa({ x, y, w, h }) {
  return (
    <g>
      <rect x={x} y={y + h * 0.2} width={w} height={h * 0.8} rx={4}
            fill="#a3a8b8" stroke="#475569" strokeWidth={0.8} fillOpacity={0.8} />
      {/* Rückenlehne */}
      <rect x={x} y={y} width={w} height={h * 0.3} rx={3}
            fill="#7c869a" stroke="#475569" strokeWidth={0.6} />
      {/* Kissen-Trennung */}
      <line x1={x + w / 2} y1={y + h * 0.3} x2={x + w / 2} y2={y + h}
            stroke="#475569" strokeOpacity={0.4} strokeWidth={0.5} />
    </g>
  );
}
function Kueche({ x, y, w, h }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={1}
            fill="#f1f5f9" stroke="#64748b" strokeWidth={0.8} fillOpacity={0.85} />
      {/* Herdplatten */}
      <circle cx={x + w * 0.25} cy={y + h * 0.3} r={Math.min(w, h) * 0.08}
              fill="#374151" stroke="#1f2937" strokeWidth={0.3} />
      <circle cx={x + w * 0.55} cy={y + h * 0.3} r={Math.min(w, h) * 0.08}
              fill="#374151" stroke="#1f2937" strokeWidth={0.3} />
      {/* Spüle */}
      <rect x={x + w * 0.7} y={y + h * 0.15} width={w * 0.25} height={h * 0.3}
            rx={1} fill="#94a3b8" stroke="#475569" strokeWidth={0.4} />
    </g>
  );
}
function WC({ x, y, w, h }) {
  return (
    <g>
      {/* Spülkasten */}
      <rect x={x} y={y} width={w} height={h * 0.3} rx={2}
            fill="#f1f5f9" stroke="#64748b" strokeWidth={0.6} />
      {/* Becken */}
      <ellipse cx={x + w / 2} cy={y + h * 0.65}
               rx={w * 0.40} ry={h * 0.30}
               fill="#fff" stroke="#64748b" strokeWidth={0.8} />
    </g>
  );
}
function Dusche({ x, y, w, h }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={2}
            fill="#dbeafe" stroke="#3b82f6" strokeWidth={0.8} fillOpacity={0.4} />
      {/* Brause */}
      <circle cx={x + w * 0.5} cy={y + h * 0.25} r={Math.min(w, h) * 0.1}
              fill="#94a3b8" stroke="#475569" strokeWidth={0.4} />
      {/* Ablauf */}
      <rect x={x + w * 0.4} y={y + h * 0.85} width={w * 0.2} height={h * 0.05}
            fill="#64748b" />
    </g>
  );
}
function Waschbecken({ x, y, w, h }) {
  return (
    <g>
      <ellipse cx={x + w / 2} cy={y + h / 2}
               rx={w * 0.45} ry={h * 0.40}
               fill="#fff" stroke="#475569" strokeWidth={0.8} />
      <circle cx={x + w / 2} cy={y + h * 0.5}
              r={Math.min(w, h) * 0.06} fill="#94a3b8" />
    </g>
  );
}
function Spiegel({ x, y, w, h }) {
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} rx={2}
            fill="rgba(135, 206, 235, 0.6)" stroke="#64748b" strokeWidth={1.2} />
      {/* Reflektion */}
      <line x1={x + w * 0.15} y1={y + h * 0.15} x2={x + w * 0.45} y2={y + h * 0.45}
            stroke="#fff" strokeOpacity={0.6} strokeWidth={1} />
      <line x1={x + w * 0.55} y1={y + h * 0.2} x2={x + w * 0.75} y2={y + h * 0.4}
            stroke="#fff" strokeOpacity={0.4} strokeWidth={0.8} />
    </g>
  );
}
function Tuer({ x, y, w, h }) {
  return (
    <g>
      <line x1={x} y1={y + h / 2} x2={x + w} y2={y + h / 2}
            stroke="#fff" strokeWidth={Math.max(2, h * 0.5)} />
      {/* Türschwung */}
      <path d={`M ${x} ${y + h / 2} A ${w} ${w} 0 0 1 ${x + w} ${y + h / 2 - w}`}
            fill="none" stroke="#94a3b8" strokeWidth={0.6} strokeDasharray="2 2" />
    </g>
  );
}
function Fenster({ x, y, w, h }) {
  return (
    <g>
      <rect x={x} y={y + h * 0.3} width={w} height={h * 0.4}
            fill="#bae6fd" stroke="#0369a1" strokeWidth={0.6} fillOpacity={0.7} />
      <line x1={x + w / 2} y1={y + h * 0.3} x2={x + w / 2} y2={y + h * 0.7}
            stroke="#0369a1" strokeWidth={0.5} />
    </g>
  );
}
function Sonstiges({ x, y, w, h }) {
  return (
    <rect x={x} y={y} width={w} height={h} rx={2}
          fill="#e5e7eb" stroke="#6b7280" strokeWidth={0.6}
          strokeDasharray="3 2" fillOpacity={0.5} />
  );
}

const RENDERERS = {
  BETT: Bett,
  TISCH: Tisch,
  STUHL: Stuhl,
  SOFA: Sofa,
  KUECHE: Kueche,
  WC: WC,
  DUSCHE: Dusche,
  WASCHBECKEN: Waschbecken,
  SPIEGEL: Spiegel,
  TUER: Tuer,
  FENSTER: Fenster,
  SONSTIGES: Sonstiges,
};

export const MOEBEL_TYPEN = [
  { typ: 'BETT', label: 'Bett', defaultW: 90, defaultH: 200 },
  { typ: 'TISCH', label: 'Tisch', defaultW: 80, defaultH: 120 },
  { typ: 'STUHL', label: 'Stuhl', defaultW: 40, defaultH: 40 },
  { typ: 'SOFA', label: 'Sofa', defaultW: 180, defaultH: 80 },
  { typ: 'KUECHE', label: 'Küche', defaultW: 200, defaultH: 60 },
  { typ: 'WC', label: 'WC', defaultW: 40, defaultH: 70 },
  { typ: 'DUSCHE', label: 'Dusche', defaultW: 80, defaultH: 80 },
  { typ: 'WASCHBECKEN', label: 'Waschbecken', defaultW: 50, defaultH: 40 },
  { typ: 'SPIEGEL', label: 'Spiegel', defaultW: 60, defaultH: 8 },
  { typ: 'TUER', label: 'Tür', defaultW: 80, defaultH: 8 },
  { typ: 'FENSTER', label: 'Fenster', defaultW: 100, defaultH: 12 },
  { typ: 'SONSTIGES', label: 'Sonstiges', defaultW: 60, defaultH: 60 },
];

export function MoebelSymbol({ moebel, onClick, selected }) {
  const g = moebel.geometry || { x: 0, y: 0, width: 50, height: 50 };
  const { x, y, width: w, height: h } = g;
  const Renderer = RENDERERS[moebel.typ] || Sonstiges;
  const rot = g.rotation || 0;
  const cx = x + w / 2;
  const cy = y + h / 2;
  const fontSize = Math.max(7, Math.min(w / 8, h / 8, 11));
  return (
    <g
      transform={rot ? `rotate(${rot} ${cx} ${cy})` : undefined}
      onClick={onClick ? (e) => { e.stopPropagation(); onClick(moebel); } : undefined}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        opacity: 0.85,
      }}
      data-testid={`moebel-${moebel.id}`}
    >
      <Renderer x={x} y={y} w={w} h={h} />
      {selected && (
        <rect x={x - 2} y={y - 2} width={w + 4} height={h + 4}
              fill="none" stroke="#dc2626" strokeWidth={1.5}
              strokeDasharray="3 2" />
      )}
      {moebel.name && Math.min(w, h) >= 30 && (
        <text x={cx} y={cy} textAnchor="middle" dominantBaseline="central"
              fontSize={fontSize} fill="#475569" fillOpacity={0.7}
              style={{ pointerEvents: 'none', userSelect: 'none' }}>
          {moebel.name}
        </text>
      )}
    </g>
  );
}

export default MoebelSymbol;
